import React, { Component } from "react";
import EditIcon from "@material-ui/icons/Edit";
import { connect } from "react-redux";
import moment from "moment";
import instance from "../../../store/actions/instance";
import { getDHLQuote } from "../../../store/actions/shipping";
import DHLLogo from "../assets/DHL.png";
import { ReactComponent as GenericShippingLogo } from "../assets/delivery-truck.svg";

import CircularProgress from "@material-ui/core/CircularProgress";
import { getCurrencyIcon } from "../../../Helpers/currencyConverter";

class Shipping extends Component {
  componentDidMount = () => {
    const { settings } = this.props;
    if (!settings.enable_dhl_dynamic_rate && !settings.enable_dhl_v2) return;
    this.props.getDHLQuote();
  };
  render() {
    const { language, settings, shipping } = this.props;

    const currency =
      language == "english"
        ? settings.currency_english
        : settings.currency_local;

    if (!shipping.loading && !shipping.data?.data?.quote_data) return <></>;
    if (!settings.enable_dhl_dynamic_rate && !settings.enable_dhl_v2)
      return <></>;

    const hasFreeDelivery =
      this.props.applied_promo?.discount_type === "delivery" ||
      this.props.discounts?.delivery?.length;
    const currencyIcon = getCurrencyIcon(settings)
    return (
      <div style={{ marginTop: 30 }}>
        <p
          className="box-title"
          style={{ textAlign: language === "arabic" ? "right" : "left" }}
        >
          {language == "english" ? "Shipping Method" : "الشحن"}
        </p>
        <div
          className="border-top border-bottom w-100 mx-0 p-3"
          style={{ backgroundColor: "white", height: 80 }}
          dir={language == "english" ? "ltr" : "rtl"}
        >
          <div
            className={"ml-0 ".concat(
              language == "english" ? "text-left" : "text-right"
            )}
            style={{
              fontSize: "1rem",
              fontWeight: 400,
              alignItems: "center",
              display: "grid",
              gridTemplateColumns: "80px auto",
              height: "100%",
              alignContent: "center",
            }}
            dir={language == "english" ? "ltr" : "rtl"}
          >
            <div className="p-2 py-3">
              {!settings.has_custom_shipping_rates ? (
                <img src={DHLLogo} style={{ width: 62, height: 35 }} />
              ) : (
                <GenericShippingLogo
                  style={{
                    width: 62,
                    height: 35,
                    transform: language === "arabic" ? "rotateY(180deg)" : "",
                  }}
                />
              )}
            </div>
            <div className="p-2 py-3">
              {shipping.loading ? (
                <span>
                  <CircularProgress
                    color="primary"
                    style={{
                      width: 20,
                      height: 20,
                      marginRight: language == "arabic" && 30,
                      marginLeft: language == "english" && 30,
                    }}
                  />{" "}
                </span>
              ) : (
                <div>
                  {!settings.has_custom_shipping_rates ? (
                    <p className="mb-1">
                      {language === "arabic"
                        ? "الشحن بواسطة"
                        : "Shipping using"}{" "}
                      <span style={{ fontWeight: "bold" }}>DHL</span>
                    </p>
                  ) : (
                    <p className="mb-1">
                      {language === "arabic"
                        ? "شحن دولي"
                        : "International Shipping"}
                    </p>
                  )}
                  {shipping.data?.data?.quote_data && (
                    <p>
                      <span style={{ fontWeight: "bold" }}>
                        {language === "arabic" ? "التكلفة" : "Cost"}:
                      </span>{" "}
                      <span
                        style={{
                          textDecoration: !!hasFreeDelivery && "line-through",
                        }}
                        className={
                          currencyIcon
                        }
                      >
                        {parseFloat(
                          shipping.data.data.quote_data.shipping_charge
                        ).toFixed(3)}{" "}
                        {currency}
                      </span>{" "}
                      {!!hasFreeDelivery && <span className="bold">Free</span>}
                    </p>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    deliveryTime: state.deliveryTime,
    settings: state.store.store.settings,
    customTexts: state.store.store.settings.custom_texts,
    shipping: state.shipping,
    address: state.customers.address,
    cart: state.cart,
    branch: state.branch,
    applied_promo: state.cart.promos,
    discounts: state.cart.discounts,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setLoading: () => dispatch({ type: "SET_SHIPPING_LOADING" }),
    fetchShippingData: (data) =>
      dispatch({ type: "FETCH_SHIPPING_DATA", payload: data }),
    getDHLQuote: () => dispatch(getDHLQuote()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Shipping);
